import { Icon, IconButton } from "@material-ui/core";
import { Product } from "domains/catalog/aggregates/Product";
import React, { FC } from "react";
import styles from "./WeighingProductSelect.module.scss";

interface WeighingProductSelectProps {
  products: Product[];
  onSelect: (product: Product) => void;
  onClose: () => void;
}

export const WeighingProductSelect: FC<WeighingProductSelectProps> = ({
  products,
  onSelect,
  onClose,
}) => {
  const onImgError = (ev: React.ChangeEvent<HTMLImageElement>) => {
    ev.target.src = require("../../../../assets/images/no-image.png");
  };

  return (
    <div id={styles.WeighingProductSelect}>
      <IconButton className={styles.close} onClick={onClose}>
        <Icon>close</Icon>
      </IconButton>

      <div className={styles.container}>
        <p className={styles.title}>Selecione o produto</p>
        <div className={styles.list}>
          {products.map((product) => (
            <button
              key={product.id}
              className={styles.item}
              onClick={() => onSelect(product)}
            >
              <img
                src={product.thumbnailUrl}
                onErrorCapture={onImgError}
                alt={product.name}
                className={styles.image}
              />
              <span className={styles.name}>{product.name}</span>
              <span className={styles.price}>
                R$ {product.price.toFixed(2).replace(".", ",")}/Kg
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
